<mat-divider></mat-divider>
<main>
  <h4>Data preference</h4>
  <div class="header-text">
    <p>
      Choose how you want to start: with an empty library where you manually import tools, or with
      demo data to explore the application.
    </p>
    <p>Demo data can also be imported later from the settings.</p>
  </div>

  <div class="cards" role="radiogroup" aria-label="Data preference">
    <mat-card
      appearance="outlined"
      role="radio"
      tabindex="0"
      [attr.aria-checked]="selectedPreference() === 'empty'"
      [class.selected]="selectedPreference() === 'empty'"
      (click)="selectPreference('empty')"
      (keydown.enter)="selectPreference('empty')"
      (keydown.space)="$event.preventDefault(); selectPreference('empty')">
      <mat-card-content>
        <div class="card-content">
          <div class="card-icon">
            <img src="/assets/inventory/tool-import.svg" alt="" aria-hidden="true" />
          </div>
          <div class="card-text">
            <p class="card-header">Start empty</p>
            <p class="card-desc">
              Begin with an empty library and manually import or add your tools
            </p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card
      appearance="outlined"
      role="radio"
      tabindex="0"
      [attr.aria-checked]="selectedPreference() === 'demo'"
      [class.selected]="selectedPreference() === 'demo'"
      (click)="selectPreference('demo')"
      (keydown.enter)="selectPreference('demo')"
      (keydown.space)="$event.preventDefault(); selectPreference('demo')">
      <mat-card-content>
        <div class="card-content">
          <div class="card-icon">
            <img src="/assets/inventory/tool-import.svg" alt="" aria-hidden="true" />
          </div>
          <div class="card-text">
            <p class="card-header">Start with demo data</p>
            <p class="card-desc">Import demo tool data to explore and try out the application</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="import-status-row">
    <div class="import-status">
      @if (isDemoImportRunning()) {
        <p>Please wait while we import demo tool data to the system.</p>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p><strong>Note:</strong> This process can take <b>a couple of minutes</b> to complete.</p>
      }
    </div>

    <div class="btn-footer">
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="onNextClick()"
        [disabled]="!canSubmit()">
        @if (isSaving()) {
          <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <span>Next</span>
        }
      </button>
    </div>
  </div>
</main>
